import AdminDashboardBreadCrumb from "components/header/AdminDashboardBreadCrumb";
import React from "react";

function AdminFileManagerIndex() {
  return (
    <main
      id="content"
      role="main"
      className="main pointer-event"
      style={{ backgroundColor: "#ffffff" }}
    >
      <div className="content container-fluid">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <AdminDashboardBreadCrumb />
            </li>
            <li className="breadcrumb-item text-capitalize" aria-current="page">
              File manager
            </li>
          </ol>
        </nav>
        <div className="d-md-flex_ align-items-center justify-content-between mb-2">
          <div className="row">
            <div className="col-md-8">
              <h3 className="h3 mb-0 text-capitalize text-black-50">
                File manager
              </h3>
            </div>
            <div className="col-md-4">
              <button
                type="button"
                className="btn btn-primary modalTrigger  float-right"
                data-toggle="modal"
                data-target="#exampleModal"
              >
                <i className="tio-add-circle" />
                <span className="text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginTop: "20px" }}>
          <div className="col-md-12">
            <div className="card">
              <div className="card-header py-1">
                <h5 className="text-capitalize">
                  public{" "}
                  <span className="badge badge-soft-dark ml-2" id="itemCount">
                    16
                  </span>
                </h5>
                <a
                  className="btn btn-primary"
                  href="/admin/business-settings/map-api"
                >
                  <i className="tio-left-arrow" />
                  Back
                </a>
              </div>
              <div className="card-body" style={{ padding: 0 }}>
                <div className="row">
                  <div className="col-sm-2">
                    <a
                      className="btn"
                      href="/admin/file-manager/index/cHVibGljL2FkbWlu"
                    >
                      <img
                        className="img-thumbnail"
                        src="https://6valley.6amtech.com/public/assets/back-end/img/folder.png"
                        alt=""
                      />
                      <p>admin</p>
                    </a>
                  </div>
                  <div className="col-sm-2">
                    <a
                      className="btn"
                      href="/admin/file-manager/index/cHVibGljL2Jhbm5lcg=="
                    >
                      <img
                        className="img-thumbnail"
                        src="https://6valley.6amtech.com/public/assets/back-end/img/folder.png"
                        alt=""
                      />
                      <p>banner</p>
                    </a>
                  </div>
                  <div className="col-sm-2">
                    <a
                      className="btn"
                      href="/admin/file-manager/index/cHVibGljL2JyYW5k"
                    >
                      <img
                        className="img-thumbnail"
                        src="https://6valley.6amtech.com/public/assets/back-end/img/folder.png"
                        alt=""
                      />
                      <p>brand</p>
                    </a>
                  </div>
                  <div className="col-sm-2">
                    <a
                      className="btn"
                      href="/admin/file-manager/index/cHVibGljL2NhdGVnb3J5"
                    >
                      <img
                        className="img-thumbnail"
                        src="https://6valley.6amtech.com/public/assets/back-end/img/folder.png"
                        alt=""
                      />
                      <p>category</p>
                    </a>
                  </div>
                  <div className="col-sm-2">
                    <a
                      className="btn"
                      href="/admin/file-manager/index/cHVibGljL2NvbXBhbnk="
                    >
                      <img
                        className="img-thumbnail"
                        src="https://6valley.6amtech.com/public/assets/back-end/img/folder.png"
                        alt=""
                      />
                      <p>company</p>
                    </a>
                  </div>
                  <div className="col-sm-2">
                    <a
                      className="btn"
                      href="/admin/file-manager/index/cHVibGljL2RlYWw="
                    >
                      <img
                        className="img-thumbnail"
                        src="https://6valley.6amtech.com/public/assets/back-end/img/folder.png"
                        alt=""
                      />
                      <p>deal</p>
                    </a>
                  </div>
                  <div className="col-sm-2">
                    <a
                      className="btn"
                      href="/admin/file-manager/index/cHVibGljL2ljb24="
                    >
                      <img
                        className="img-thumbnail"
                        src="https://6valley.6amtech.com/public/assets/back-end/img/folder.png"
                        alt=""
                      />
                      <p>icon</p>
                    </a>
                  </div>
                  <div className="col-sm-2">
                    <a
                      className="btn"
                      href="/admin/file-manager/index/cHVibGljL2xvZ28="
                    >
                      <img
                        className="img-thumbnail"
                        src="https://6valley.6amtech.com/public/assets/back-end/img/folder.png"
                        alt=""
                      />
                      <p>logo</p>
                    </a>
                  </div>
                  <div className="col-sm-2">
                    <a
                      className="btn"
                      href="/admin/file-manager/index/cHVibGljL25vdGlmaWNhdGlvbg=="
                    >
                      <img
                        className="img-thumbnail"
                        src="https://6valley.6amtech.com/public/assets/back-end/img/folder.png"
                        alt=""
                      />
                      <p>notificati...</p>
                    </a>
                  </div>
                  <div className="col-sm-2">
                    <a
                      className="btn"
                      href="/admin/file-manager/index/cHVibGljL3BuZw=="
                    >
                      <img
                        className="img-thumbnail"
                        src="https://6valley.6amtech.com/public/assets/back-end/img/folder.png"
                        alt=""
                      />
                      <p>png</p>
                    </a>
                  </div>
                  <div className="col-sm-2">
                    <a
                      className="btn"
                      href="/admin/file-manager/index/cHVibGljL3Byb2R1Y3Q="
                    >
                      <img
                        className="img-thumbnail"
                        src="https://6valley.6amtech.com/public/assets/back-end/img/folder.png"
                        alt=""
                      />
                      <p>product</p>
                    </a>
                  </div>
                  <div className="col-sm-2">
                    <a
                      className="btn"
                      href="/admin/file-manager/index/cHVibGljL3Byb2ZpbGU="
                    >
                      <img
                        className="img-thumbnail"
                        src="https://6valley.6amtech.com/public/assets/back-end/img/folder.png"
                        alt=""
                      />
                      <p>profile</p>
                    </a>
                  </div>
                  <div className="col-sm-2">
                    <a
                      className="btn"
                      href="/admin/file-manager/index/cHVibGljL3Jldmlldw=="
                    >
                      <img
                        className="img-thumbnail"
                        src="https://6valley.6amtech.com/public/assets/back-end/img/folder.png"
                        alt=""
                      />
                      <p>review</p>
                    </a>
                  </div>
                  <div className="col-sm-2">
                    <a
                      className="btn"
                      href="/admin/file-manager/index/cHVibGljL3NlbGxlcg=="
                    >
                      <img
                        className="img-thumbnail"
                        src="https://6valley.6amtech.com/public/assets/back-end/img/folder.png"
                        alt=""
                      />
                      <p>seller</p>
                    </a>
                  </div>
                  <div className="col-sm-2">
                    <a
                      className="btn"
                      href="/admin/file-manager/index/cHVibGljL3Nob3A="
                    >
                      <img
                        className="img-thumbnail"
                        src="https://6valley.6amtech.com/public/assets/back-end/img/folder.png"
                        alt=""
                      />
                      <p>shop</p>
                    </a>
                  </div>
                  <div className="col-sm-2">
                    <button
                      className="btn w-100"
                      data-toggle="modal"
                      data-target="#imagemodal15"
                      title="def.png"
                    >
                      <div className="gallary-card">
                        <img
                          src="https://6valley.6amtech.com/storage/app/public/def.png"
                          alt="def.png"
                          style={{ height: "auto", width: "100%" }}
                        />
                      </div>
                      <p style={{ overflow: "hidden" }}>def.png</p>
                    </button>
                    <div
                      className="modal fade"
                      id="imagemodal15"
                      tabIndex={-1}
                      role="dialog"
                      aria-labelledby="myModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h4 className="modal-title" id="myModalLabel">
                              def.png
                            </h4>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                            >
                              <span aria-hidden="true">×</span>
                              <span className="sr-only">Close</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <img
                              src="https://6valley.6amtech.com/storage/app/public/def.png"
                              style={{ width: "100%", height: "auto" }}
                            />
                          </div>
                          <div className="modal-footer">
                            <a
                              className="btn btn-primary"
                              href="/admin/file-manager/download/cHVibGljL2RlZi5wbmc="
                            >
                              <i className="tio-download" /> Download{" "}
                            </a>
                            <button
                              className="btn btn-info"
                              onclick="copy_test('def.png')"
                            >
                              <i className="tio-copy" /> Copy path
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <div className="page-area"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="exampleModal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="indicator" />
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Upload File{" "}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <input
                    type="hidden"
                    name="_token"
                    defaultValue="u6GOrXsoRaqVCSqDXnArevLM6wUEqejL2jE0AoWi"
                  />{" "}
                  <input type="text" name="path" defaultValue="public" hidden />
                  <div className="form-group">
                    <div className="custom-file">
                      <input
                        type="file"
                        name="images[]"
                        id="customFileUpload"
                        className="custom-file-input"
                        accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*"
                        multiple
                      />
                      <label
                        className="custom-file-label"
                        htmlFor="customFileUpload"
                      >
                        Choose Images
                      </label>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="custom-file">
                      <input
                        type="file"
                        name="file"
                        id="customZipFileUpload"
                        className="custom-file-input"
                        accept=".zip"
                      />
                      <label
                        className="custom-file-label"
                        id="zipFileLabel"
                        htmlFor="customZipFileUpload"
                      >
                        Upload zip file
                      </label>
                    </div>
                  </div>
                  <div className="row" id="files" />
                  <div className="form-group">
                    <input
                      className="btn btn-primary"
                      type="button"
                      onclick="call_demo()"
                      defaultValue="Upload"
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer"></div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default AdminFileManagerIndex;
